<script>
  import {
    DataTable,
    Button,
    Modal,
    TextInput,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    Link,
    Pagination,
  } from "carbon-components-svelte";
  import { ROUTES } from "@utils/routes.js";
  import { useNavigate } from "svelte-navigator";
  import { fly } from "svelte/transition";
  import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";
  import Share16 from "carbon-icons-svelte/lib/Share16";
  import Copy16 from "carbon-icons-svelte/lib/Copy16";
  import Edit16 from "carbon-icons-svelte/lib/Edit16";
  import View16 from "carbon-icons-svelte/lib/View16";
  import Add16 from "carbon-icons-svelte/lib/Add16";

  import ButtonDefault from "../../../lib/components/Button.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import Header from "lib/components/Header.svelte";
  import { SectionWrapper } from "paxray-components-svelte";
  import { onMount } from "svelte";

  const navigate = useNavigate();

  let inprogressForms = [];
  let finishedForms = [];
  let filteredProgressForms = [];
  let filteredFinishedForms = [];
  let progressFilter = "";
  let finishedFilter = "";
  // let newFormModalOpen = false;
  // let newFormName = "";
  let analysispage = 1;
  let analysispagesize = 10;
  let finishedPage = 1;
  let finishedPageSize = 10;
  let selectedSurvey;
  let selectedAnswers = 0;
  let openDeleteModal = false;
  let openSendModal = false;
  let selectedSurveyName = "";
  let currentTime = new Date();


  let headers = [
    { key: "name", value: "Name" },
    { key: "status", value: "Status" },
    { key: "send", value: "Invitations", width: "6rem" },
    { key: "preview", value: "Preview", width: "6rem" },
    { key: "edit", value: "Edit", width: "6rem" },
    //{ key: "share", value: "Share", width: "6rem" },
    { key: "delete", value: "Delete", width: "6rem" },
  ];

  $: getFiltersProgressForms(progressFilter);
  $: getFiltersFinishedForms(finishedFilter);
  $: hasAnswers(selectedSurvey);

  function getFiltersProgressForms(progressFilter) {
    if (!progressFilter) {
      filteredProgressForms = inprogressForms;
      return;
    }
    filteredProgressForms = inprogressForms.filter((inprogressForm) =>
      inprogressForm.name.toLowerCase().includes(progressFilter.toLowerCase()),
    );
  }
  function getFiltersFinishedForms(finishedFilter) {
    if (!finishedFilter) {
      filteredFinishedForms = finishedForms;
      return;
    }
    filteredFinishedForms = finishedForms.filter((finishedForm) =>
      finishedForm.name.toLowerCase().includes(finishedFilter.toLowerCase()),
    );
  }

  function getData() {
    fetchWithSession("/api/knextractor/surveys", {
      method: "GET",
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          console.error("Error fetching forms");
        }
      })
      .then((res) => {
        inprogressForms = res
          .filter((survey) => survey.status !== "FINISHED")
          .sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        filteredProgressForms = inprogressForms;
        finishedForms = res
          .filter((survey) => survey.status === "FINISHED")
          .sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        filteredFinishedForms = finishedForms;
      });
  }

  function hasAnswers(selectedSurvey) {
    if (!selectedSurvey) return;
    fetchWithSession("/api/knextractor/surveys/" + selectedSurvey, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        selectedAnswers = data.survey_tasks.reduce(
          (sum, task) => sum + task.answers_count,
          0,
        );
      });
  }

  function deleteSurvey() {
    fetchWithSession("/api/knextractor/surveys/" + selectedSurvey, {
      method: "DELETE",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          return;
        }
        openDeleteModal = false;
        selectedSurvey = "";
        // Refresh the data after deletion
        getData();
      });
  }

  function getNextSendTime(startDate) {
    const now = currentTime;
    const nextSend = new Date(now);
    nextSend.setHours(9, 0, 0, 0);
    if (nextSend <= now) nextSend.setDate(nextSend.getDate() + 1);

    const surveyStart = new Date(`${startDate}T09:00:00`);
    return surveyStart > nextSend ? surveyStart : nextSend;
  }

  function formatCountdown(startDate) {
    const remainingMinutes = Math.max(
      0,
      Math.ceil((getNextSendTime(startDate) - currentTime) / 60000),
    );
    const hours = Math.floor(remainingMinutes / 60);
    const minutes = remainingMinutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  }

  function sendInstant() {
    fetchWithSession(`/api/knextractor/surveys/${selectedSurvey}/send-emails`, {
      method: "POST",
    })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Email sending failed");
        return data;
      })
      .then((data) => {
        openSendModal = false;
        getData();
      })
      .catch((sendError) => {
        openSendModal = false;
      });
  }

  onMount(() => {
    getData();
    const countdownInterval = setInterval(() => {
      currentTime = new Date();
    }, 30000);
    return () => clearInterval(countdownInterval);
  });
</script>

<Header section="Surveys" breadcrumb="Overview">
  <ButtonDefault
    on:click={() => {
      navigate(`${ROUTES.knex.form}`);
    }}
    iconComponent={Add16}
    variant="secondary"
    text="New Survey"
  />
</Header>
<SectionWrapper fullscreen={true}>
  <div class="main" slot="main">
    <div class="top_menu in_progress">
      <div class="sub_heading bold">Surveys Ready for Analysis</div>
    </div>

    <DataTable
      headers={[
        { key: "name", value: "Name" },
        { key: "status", value: "Status" },
        { key: "delete", value: "Delete", width: "5rem" },
      ]}
      rows={filteredFinishedForms}
      sortable
    >
      <Toolbar>
        <ToolbarContent>
          <ToolbarSearch bind:value={finishedFilter} />
        </ToolbarContent>
      </Toolbar>
      <span slot="cell" let:row let:cell>
        {#if cell.key == "name"}
          <button
            type="button"
            class="name_link"
            on:click={() =>
              navigate(
                `${ROUTES.knex.potentialScope.dashboard}?survey=${row.id}`,
              )}
          >
            {cell.value}
          </button>
        {:else if cell.key == "status"}
          {cell.value.charAt(0).toUpperCase() +
            cell.value.slice(1).toLowerCase()}
        {:else if cell.key == "share"}
          <Button
            size="small"
            kind="tertiary"
            icon={Share16}
            disabled={true}
            on:click={() => {
              //shareSurvey(row.id);
            }}
            iconDescription="Share"
          />
        {:else if cell.key == "delete"}
          <Button
            size="small"
            kind="danger-tertiary"
            icon={TrashCan16}
            on:click={() => {
              selectedSurvey = row.id;
              openDeleteModal = true;
              //deleteSurvey(row.id, "running");
            }}
            iconDescription="Delete"
          />
        {:else}
          {cell.value}
        {/if}
      </span>
    </DataTable>
    <Pagination
      bind:page={finishedPage}
      bind:pageSize={finishedPageSize}
      pageSizes={[10, 15, 20]}
      totalItems={filteredFinishedForms.length}
    />
    <div class="top_menu">
      <div class="sub_heading bold">Surveys in Progress</div>
    </div>
    <DataTable rows={filteredProgressForms} {headers} sortable>
      <Toolbar>
        <ToolbarContent>
          <ToolbarSearch bind:value={progressFilter} />
        </ToolbarContent>
      </Toolbar>
      <span slot="cell" let:row let:cell>
        {#if cell.key == "name"}
          <button
            type="button"
            class="name_link"
            on:click={() =>
              navigate(
                `${ROUTES.knex.potentialScope.dashboard}?survey=${row.id}`,
              )}
          >
            {cell.value}
          </button>
        {:else if cell.key == "status"}
          {cell.value.charAt(0).toUpperCase() +
            cell.value.slice(1).toLowerCase()}
        {:else if cell.key == "send"}
          {#if row.pending_invitations > 0}
            <button
              class="send_countdown"
              title="Send {row.pending_invitations} pending invitation(s) now"
              on:click={() => {
                selectedSurvey = row.id;
                selectedSurveyName = row.name;
                openSendModal = true;
              }}
            >
              {formatCountdown(row.start_date)}
            </button>
          {:else}
            <span class="sent">Sent</span>
          {/if}
        {:else if cell.key == "preview"}
          <Button
            size="small"
            kind="tertiary"
            icon={View16}
            on:click={() =>
              window.open(
                `${ROUTES.knex.survey}?preview=${row.id}`,
                "_blank",
                "noopener,noreferrer",
              )}
            iconDescription="Preview survey"
          />
        {:else if cell.key == "edit"}
          <Button
            size="small"
            kind="tertiary"
            disabled={row.status === "RUNNING"}
            icon={Edit16}
            on:click={() => {
              //editSurvey(row.id);
              navigate(`${ROUTES.knex.form}?survey=${row.id}`);
            }}
            iconDescription="Edit"
          />
          <!-- {:else if cell.key == "share"}
          <Button
            size="small"
            kind="tertiary"
            disabled={false}
            icon={Share16}
            on:click={() => {
              navigate(`${ROUTES.knex.survey}?survey=${row.id}`);
              //shareSurvey(row.id);
            }}
            iconDescription="Share"
          /> -->
        {:else if cell.key == "delete"}
          <Button
            size="small"
            kind="danger-tertiary"
            icon={TrashCan16}
            on:click={() => {
              selectedSurvey = row.id;
              openDeleteModal = true;
              //deleteSurvey(row.id, "analysis");
            }}
            iconDescription="Delete"
          />
        {:else}
          {cell.value}
        {/if}
      </span>
    </DataTable>
    <Pagination
      bind:page={analysispage}
      bind:pageSize={analysispagesize}
      pageSizes={[10, 15, 20]}
      totalItems={filteredProgressForms.length}
    />
  </div>
</SectionWrapper>



<!-- <Modal
  bind:open={newFormModalOpen}
  modalHeading="Enter new form name"
  primaryButtonText="Create"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => {
    newFormModalOpen = false;
  }}
  on:close={() => {
    newFormModalOpen = false;
  }}
  on:submit={createNewForm}
>
  <p>Form Name</p>
  <TextInput label="Name" bind:value={newFormName} />
</Modal> -->

<Modal
  preventCloseOnClickOutside
  bind:open={openDeleteModal}
  danger
  modalHeading="Delete selection"
  primaryButtonText="Confirm"
  secondaryButtonText="Cancel"
  on:submit={() => {
    deleteSurvey();
    openDeleteModal = false;
  }}
  on:click:button--secondary={() => (openDeleteModal = false)}
  ><h5>Do you really want to delete this survey?</h5>
  {#if selectedAnswers}
    This survey has {selectedAnswers} responses, they will also be deleted.
  {/if}
  <p class="orange">This action cannot be undone</p>
</Modal>

<Modal
  preventCloseOnClickOutside
  bind:open={openSendModal}
  danger
  modalHeading="Send invitations now?"
  primaryButtonText="Send instant"
  secondaryButtonText="Cancel"
  on:submit={sendInstant}
  on:click:button--secondary={() => (openSendModal = false)}
>
  <p>
    All pending invitations for <strong>{selectedSurveyName}</strong> will be
    sent immediately. If the survey is scheduled for a future date, it will be
    opened today. The scheduled automatic send will be skipped for these recipients.
  </p>
</Modal>

<style>
  .main {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    width: 100%;
    gap: 1.6rem;
  }

  .name_link {
    border: 0;
    padding: 0;
    background: none;
    font: inherit;
    text-align: left;
    cursor: pointer;
  }
  .orange {
    color: var(--pax-orange);
    font-weight: bold;
  }
  .send_countdown {
    border: 0;
    background: none;
    color: var(--pax-orange);
    cursor: pointer;
    font: inherit;
    font-variant-numeric: tabular-nums;
    text-decoration: underline;
  }
  .sent {
    color: var(--cds-text-secondary, #525252);
  }
</style>
